export default {"src":"/_next/static/media/ambulance.db6e44ff.svg","height":81,"width":91};